export const ERROR_PAGE_CONTAINER = 'error-page-container';
